import styled from 'styled-components';

// Fills the viewport and centers the brand while the app shell boots. Fixed
// positioning escapes any parent layout, so it's always dead-center.
export const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--body-bg);
`;

// Logo + label stacked and centered, matching the server boot screen so the
// pre-mount → React handoff is seamless.
export const Brand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;

  svg {
    width: 180px;
    fill: var(--text-muted);
  }

  @media (min-width: 1200px) {
    svg {
      width: 260px;
    }
  }
`;

export const Label = styled.span`
  /* Match the server boot screen's system font so the pre-mount → React
     handoff shows no font shift. */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.35em;
  /* Compensate the trailing letter-spacing so the word stays centered. */
  padding-left: 0.35em;
  line-height: 1;
  margin: 0;
  color: var(--text-muted);

  @media (min-width: 1200px) {
    font-size: 15px;
  }
`;
